import { render, staticRenderFns } from "./CasItems.vue?vue&type=template&id=67223f4b&scoped=true&"
import script from "./CasItems.vue?vue&type=script&lang=js&"
export * from "./CasItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67223f4b",
  null
  
)

export default component.exports